module.exports = __webpack_public_path__ + "e3b1c58234206366cc113468d0e6cfd7.png";